import StringHelper from "./StringHelper";

export default function OnlyNumber(event) {
    const key = event.key;
    if (!key || key.length !== 1) {
        return;
    }
    const keyValue = StringHelper.getEnglishNum(key);
    if (!/[0-9]/.test(keyValue)) {
        event.preventDefault();
    }
}
